/**
 * The journey cohort marker every ecommerce analytics payload carries.
 *
 * Guest Checkout runs alongside the legacy DesignMyNight booking widget, and
 * both report bookings for the same venues. Without a marker on the events
 * themselves a report cannot tell the two apart, so funnel completion and
 * per-step timings cannot be compared like for like.
 *
 * It is a cohort version, not the `postMessage` envelope's protocol `version`:
 * it names which checkout produced the event and changes only when the journey
 * itself is replaced. See `docs/analytics.md`.
 */
export const JOURNEY_VERSION = "guest-checkout-v2";
